document.addEventListener('DOMContentLoaded', function() {
  // Sélectionne le bouton LIVRAISON EUROPE (adapte le sélecteur si besoin)
  const livraisonEuropeBtn = document.querySelector('[data-shipping-method="europe"], .livraison-europe, #livraison-europe, button[aria-label*="LIVRAISON EUROPE"]');

  if (livraisonEuropeBtn) {
    livraisonEuropeBtn.addEventListener('click', function() {
      // On enregistre la préférence dans les attributs du panier
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            preferred_delivery_method: 'shipping'   // ou 'livraison'
          }
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Préférence livraison Europe enregistrée');
        // Optionnel : force le rechargement du panier si besoin
        // location.reload();
      })
      .catch(err => console.error(err));
    });
  }
});